/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.2.20171210
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
// jshint ignore: start
if ("document" in self) {

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList
    if (
        !("classList" in document.createElement("_"))
        || document.createElementNS
        && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))
    ) {

        (function (view) {

            "use strict";

            if (!('Element' in view)) return;

            var
                classListProp = "classList"
                , protoProp = "prototype"
                , elemCtrProto = view.Element[protoProp]
                , objCtr = Object
                , strTrim = String[protoProp].trim || function () {
                    return this.replace(/^\s+|\s+$/g, "");
                }
                , arrIndexOf = Array[protoProp].indexOf || function (item) {
                    var
                        i = 0
                        , len = this.length
                    ;
                    for (; i < len; i++) {
                        if (i in this && this[i] === item) {
                            return i;
                        }
                    }
                    return -1;
                }
                // Vendors: please allow content code to instantiate DOMExceptions
                , DOMEx = function (type, message) {
                    this.name = type;
                    this.code = DOMException[type];
                    this.message = message;
                }
                , checkTokenAndGetIndex = function (classList, token) {
                    if (token === "") {
                        throw new DOMEx(
                            "SYNTAX_ERR"
                            , "The token must not be empty."
                        );
                    }
                    if (/\s/.test(token)) {
                        throw new DOMEx(
                            "INVALID_CHARACTER_ERR"
                            , "The token must not contain space characters."
                        );
                    }
                    return arrIndexOf.call(classList, token);
                }
                , ClassList = function (elem) {
                    var
                        trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
                        , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
                        , i = 0
                        , len = classes.length
                    ;
                    for (; i < len; i++) {
                        this.push(classes[i]);
                    }
                    this._updateClassName = function () {
                        elem.setAttribute("class", this.toString());
                    };
                }
                , classListProto = ClassList[protoProp] = []
                , classListGetter = function () {
                    return new ClassList(this);
                }
            ;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
            DOMEx[protoProp] = Error[protoProp];
            classListProto.item = function (i) {
                return this[i] || null;
            };
            classListProto.contains = function (token) {
                return ~checkTokenAndGetIndex(this, token + "");
            };
            classListProto.add = function () {
                var
                    tokens = arguments
                    , i = 0
                    , l = tokens.length
                    , token
                    , updated = false
                ;
                do {
                    token = tokens[i] + "";
                    if (!~checkTokenAndGetIndex(this, token)) {
                        this.push(token);
                        updated = true;
                    }
                }
                while (++i < l);

                if (updated) {
                    this._updateClassName();
                }
            };
            classListProto.remove = function () {
                var
                    tokens = arguments
                    , i = 0
                    , l = tokens.length
                    , token
                    , updated = false
                    , index
                ;
                do {
                    token = tokens[i] + "";
                    index = checkTokenAndGetIndex(this, token);
                    while (~index) {
                        this.splice(index, 1);
                        updated = true;
                        index = checkTokenAndGetIndex(this, token);
                    }
                }
                while (++i < l);

                if (updated) {
                    this._updateClassName();
                }
            };
            classListProto.toggle = function (token, force) {
                var
                    result = this.contains(token)
                    , method = result ?
                    force !== true && "remove"
                    :
                    force !== false && "add"
                ;

                if (method) {
                    this[method](token);
                }

                if (force === true || force === false) {
                    return force;
                } else {
                    return !result;
                }
            };
            classListProto.replace = function (token, replacement_token) {
                var index = checkTokenAndGetIndex(token + "");
                if (~index) {
                    this.splice(index, 1, replacement_token);
                    this._updateClassName();
                }
            }
            classListProto.toString = function () {
                return this.join(" ");
            };

            if (objCtr.defineProperty) {
                var classListPropDesc = {
                    get: classListGetter
                    , enumerable: true
                    , configurable: true
                };
                try {
                    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                } catch (ex) { // IE 8 doesn't support enumerable:true
                    // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
                    // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
                    if (ex.number === undefined || ex.number === -0x7FF5EC54) {
                        classListPropDesc.enumerable = false;
                        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                    }
                }
            } else if (objCtr[protoProp].__defineGetter__) {
                elemCtrProto.__defineGetter__(classListProp, classListGetter);
            }

        }(self));

    }

// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

    (function () {
        "use strict";

        var testElement = document.createElement("_");

        testElement.classList.add("c1", "c2");

        // Polyfill for IE 10/11 and Firefox <26, where classList.add and
        // classList.remove exist but support only one argument at a time.
        if (!testElement.classList.contains("c2")) {
            var createMethod = function(method) {
                var original = DOMTokenList.prototype[method];

                DOMTokenList.prototype[method] = function(token) {
                    var i, len = arguments.length;

                    for (i = 0; i < len; i++) {
                        token = arguments[i];
                        original.call(this, token);
                    }
                };
            };
            createMethod('add');
            createMethod('remove');
        }

        testElement.classList.toggle("c3", false);

        // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
        // support the second argument.
        if (testElement.classList.contains("c3")) {
            var _toggle = DOMTokenList.prototype.toggle;

            DOMTokenList.prototype.toggle = function(token, force) {
                if (1 in arguments && !this.contains(token) === !force) {
                    return force;
                } else {
                    return _toggle.call(this, token);
                }
            };

        }

        // replace() polyfill
        if (!("replace" in document.createElement("_").classList)) {
            DOMTokenList.prototype.replace = function (token, replacement_token) {
                var
                    tokens = this.toString().split(" ")
                    , index = tokens.indexOf(token + "")
                ;
                if (~index) {
                    tokens = tokens.slice(index);
                    this.remove.apply(this, tokens);
                    this.add(replacement_token);
                    this.add.apply(this, tokens.slice(1));
                }
            }
        }

        testElement = null;
    }());
}

/* Polyfill service v3.25.1
 * For detailed credits and licence information see https://github.com/financial-times/polyfill-service.
 *
 * UA detected: ie/9.0.0
 * Features requested: matchMedia
 *
 * - Event, License: CC0 (required by "matchMedia")
 * - matchMedia, License: CC0 */

(function(undefined) {

// Event
    (function () {
        var unlistenableWindowEvents = {
            click: 1,
            dblclick: 1,
            keyup: 1,
            keypress: 1,
            keydown: 1,
            mousedown: 1,
            mouseup: 1,
            mousemove: 1,
            mouseover: 1,
            mouseenter: 1,
            mouseleave: 1,
            mouseout: 1,
            storage: 1,
            storagecommit: 1,
            textinput: 1
        };

        // This polyfill depends on availability of `document` so will not run in a worker
        // However, we asssume there are no browsers with worker support that lack proper
        // support for `Event` within the worker
        if (typeof document === 'undefined' || typeof window === 'undefined') return;

        function indexOf(array, element) {
            var
                index = -1,
                length = array.length;

            while (++index < length) {
                if (index in array && array[index] === element) {
                    return index;
                }
            }

            return -1;
        }

        var existingProto = (window.Event && window.Event.prototype) || null;
        window.Event = Window.prototype.Event = function Event(type, eventInitDict) {
            if (!type) {
                throw new Error('Not enough arguments');
            }

            var event;
            // Shortcut if browser supports createEvent
            if ('createEvent' in document) {
                event = document.createEvent('Event');
                var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

                event.initEvent(type, bubbles, cancelable);

                return event;
            }

            event = document.createEventObject();

            event.type = type;
            event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
            event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

            return event;
        };
        if (existingProto) {
            Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
        }

        if (!('createEvent' in document)) {
            window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                var
                    element = this,
                    type = arguments[0],
                    listener = arguments[1];

                if (element === window && type in unlistenableWindowEvents) {
                    throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                }

                if (!element._events) {
                    element._events = {};
                }

                if (!element._events[type]) {
                    element._events[type] = function (event) {
                        var
                            list = element._events[event.type].list,
                            events = list.slice(),
                            index = -1,
                            length = events.length,
                            eventElement;

                        event.preventDefault = function preventDefault() {
                            if (event.cancelable !== false) {
                                event.returnValue = false;
                            }
                        };

                        event.stopPropagation = function stopPropagation() {
                            event.cancelBubble = true;
                        };

                        event.stopImmediatePropagation = function stopImmediatePropagation() {
                            event.cancelBubble = true;
                            event.cancelImmediate = true;
                        };

                        event.currentTarget = element;
                        event.relatedTarget = event.fromElement || null;
                        event.target = event.target || event.srcElement || element;
                        event.timeStamp = new Date().getTime();

                        if (event.clientX) {
                            event.pageX = event.clientX + document.documentElement.scrollLeft;
                            event.pageY = event.clientY + document.documentElement.scrollTop;
                        }

                        while (++index < length && !event.cancelImmediate) {
                            if (index in events) {
                                eventElement = events[index];

                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') {
                                    eventElement.call(element, event);
                                }
                            }
                        }
                    };

                    element._events[type].list = [];

                    if (element.attachEvent) {
                        element.attachEvent('on' + type, element._events[type]);
                    }
                }

                element._events[type].list.push(listener);
            };

            window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                var
                    element = this,
                    type = arguments[0],
                    listener = arguments[1],
                    index;

                if (element._events && element._events[type] && element._events[type].list) {
                    index = indexOf(element._events[type].list, listener);

                    if (index !== -1) {
                        element._events[type].list.splice(index, 1);

                        if (!element._events[type].list.length) {
                            if (element.detachEvent) {
                                element.detachEvent('on' + type, element._events[type]);
                            }
                            delete element._events[type];
                        }
                    }
                }
            };

            window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                if (!arguments.length) {
                    throw new Error('Not enough arguments');
                }

                if (!event || typeof event.type !== 'string') {
                    throw new Error('DOM Events Exception 0');
                }

                var element = this, type = event.type;

                try {
                    if (!event.bubbles) {
                        event.cancelBubble = true;

                        var cancelBubbleEvent = function (event) {
                            event.cancelBubble = true;

                            (element || window).detachEvent('on' + type, cancelBubbleEvent);
                        };

                        this.attachEvent('on' + type, cancelBubbleEvent);
                    }

                    this.fireEvent('on' + type, event);
                } catch (error) {
                    event.target = element;

                    do {
                        event.currentTarget = element;

                        if ('_events' in element && typeof element._events[type] === 'function') {
                            element._events[type].call(element, event);
                        }

                        if (typeof element['on' + type] === 'function') {
                            element['on' + type].call(element, event);
                        }

                        element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                    } while (element && !event.cancelBubble);
                }

                return true;
            };

            // Add the DOMContentLoaded Event
            document.attachEvent('onreadystatechange', function() {
                if (document.readyState === 'complete') {
                    document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                }
            });
        }
    }());
})
    .call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof global && global || {});
